<script setup lang="ts">
const props = defineProps({
  rarity: {
    type: String,
    required: true,
  },
  properties: {
    type: Object as PropType<{ [key: string]: Property }>,
    required: true,
  },
  merchantId: {
    type: String,
    required: true,
  },
});

const sortedProperties = computed(() => {
  return Object.entries(props.properties)
    .filter(([, value]) => value.type === "CORE")
    .sort(([, a], [, b]) => a.order - b.order);
});
</script>
<template>
  <div class="border-b-2 last-of-type:border-b-0 border-primary-900 px-7 py-5">
    <p class="text-neutral-200 font-bold text-base">
      {{ $t("main.storeDetail.properties") }}
    </p>
    <div class="mt-3 font-light flex flex-wrap gap-4">
      <p
        v-if="rarity"
        class="min-w-[80px] h-6 py-1 px-2 text-center rounded-xs text-xs"
        :class="getRarityColor(rarity, 'bg')">
        {{ $t(`main.property.rarity.${rarity}`) }}
      </p>
      <template
        v-for="[propertyName, property] in sortedProperties"
        :key="propertyName">
        <p
          class="min-w-[80px] h-6 py-1 px-2 text-center rounded-xs text-xs bg-primary-900 text-neutral-200">
          {{
            $t(`${merchantId}.property.${propertyName}.title`) +
            ": " +
            ($te(
              `${merchantId}.property.${propertyName}.values.${property.value}`
            )
              ? $t(
                  `${merchantId}.property.${propertyName}.values.${property.value}`
                )
              : property.value)
          }}
        </p>
      </template>
    </div>
  </div>
</template>
